import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface Props {
  open: boolean;
  blockers: string[];
  tableName?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Shown when a drop violates soft business rules (capacity, allowsChildren,
 * allowsStroller, …). Staff can still force the assignment — physical
 * overlap and locked reservations remain rejected by the SQL trigger.
 */
export const ForceDropDialog = ({ open, blockers, tableName, onConfirm, onCancel }: Props) => {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
            Assignation à confirmer
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 text-sm">
              <div>
                Cette assignation {tableName ? `sur « ${tableName} »` : ""} ne respecte pas certaines règles :
              </div>
              <ul className="list-disc pl-5 space-y-1 text-foreground">
                {blockers.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
              <div className="text-muted-foreground pt-1">
                Vous pouvez forcer l'assignation. Les contraintes physiques (chevauchement, verrouillage) restent bloquantes.
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-amber-600 hover:bg-amber-700">
            Assigner quand même
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
